import React, { useEffect, useState } from 'react'
import { Grid, Switch, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { connect, useDispatch } from 'react-redux'
import { compose } from 'recompose'
import themeCreateInjectableStyles from '../../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import NotificationConfigStyles from './NotificationConfig.styles'
import { NotificationConfig, NotificationConfigDevice } from 'types/NotificationConfig'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { getGATypeNotificationSettings } from './utils/GATypeMapping'

interface Props {
  headline: string,
  description: string,
  onChange(config: NotificationConfig): void,
  config: NotificationConfig,
  classes?: any,
}

const NotificationConfigCompRaw = (props: Props) => {
  const {
    headline,
    description,
    onChange = () => {},
    config,
    classes,
  } = props
  const dispatch = useDispatch()
  const toggleChecked = (name: NotificationConfigDevice) => () => {
    const changingDevice = name
    const upcomingValue = !config.values[name]
    const upcomingConfig = {
      ...config,
      values: {
        ...config.values,
        [changingDevice]: upcomingValue,
      },
    }
    dispatch(hitGTM(getGATypeNotificationSettings(upcomingConfig, upcomingValue, changingDevice)))
    onChange(upcomingConfig)
  }
  if (!config) {
    return null
  }
  return (
    <Grid container spacing={2} className={classes.flexWrapNowrap}>
      <Grid item className={cn(classes.flexGrow1)}>
        <Typography variant='body1' className={classes.fontWeight500}>
          { headline }
        </Typography>
        <Typography variant='body2'>
          { description }
        </Typography>
      </Grid>
      <Grid item className={cn(classes.switches)}>
        <Grid container>
          <Grid item xs={6}>
            <Switch
              color='primary'
              checked={config.values.inApp}
              onChange={toggleChecked(NotificationConfigDevice.InApp)}
            />
          </Grid>
          <Grid item xs={6}>
            <Switch
              color='primary'
              checked={config.values.sms}
              onChange={toggleChecked(NotificationConfigDevice.SMS)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const NotificationConfigComp = compose<Props, Props>(
  withStyles(themeCreateInjectableStyles(NotificationConfigStyles) as any, { withTheme: true }),
)(NotificationConfigCompRaw)

export default NotificationConfigComp
